import React from "react"
import clsx from "clsx"
import FormFieldBuilderErrors from "../FormFieldBuilderErrors"
class FormFieldBuilderEmojiRating extends React.Component {

  constructor(props) {
    super(props)
  }

  /*** Render Functions ***/

  render() {   
    var tabClasses = clsx({
      'active': this.props.active_tab == 'emoji_rating',
      'tab-pane': true 
    })

    return (
      <div className={tabClasses} id='emoji_rating'>
        {this.renderErrors()} 
        {this.renderEmojiRatingForm()}
        {this.renderEmojiRatingPreview()}
      </div>
    )
  }

  renderErrors() {
    var errors = FormFieldBuilderErrors.ratingScaleErrors(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  renderEmojiRatingForm() {
    return (
      <div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('preview')}</label>
              <div>{this.props.field}</div>
              {this.renderFieldErrors("label")}
            </div>
          </div>
        </div>  
      </div>
    )
  }

  renderEmojiRatingPreview(){
    return (
      <div className="row">
        <div className="col-md-4">
          <div className="form_group">
            <label>{this.props.emoji_rating_label}</label>
            <div className="rating-scale-div">
              {this.renderEmojiRatingRange()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderEmojiRatingRange() {
    var rating_range = 5
    var rating_range_arr = []

    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }

    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 5) {
        if(rating == 1) {
          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {
          var list_emoji = <i className="far fa-frown fa-2x"></i>   
        } else if (rating == 3) {
          var list_emoji = <i className="far fa-meh fa-2x"></i>
        } else if (rating == 4) {
          var list_emoji = <i className="far fa-smile fa-2x"></i>  
        } else {
          var list_emoji = <i className="far fa-grin fa-2x"></i>
        } 
      }  
      return (
        <li className={this.props.selected == true && this.props.selected_rating == rating ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.props.onChangeSelectedRating(rating)} key={rating}>{list_emoji}</li>
      )
    })
  
    if(this.props.rating_range != 'none') {
      return (
        <ul className="emoji-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 
  }
}

export default FormFieldBuilderEmojiRating